/**
 * Data Model
 */
export interface Plot {
  novelId: string;
  plotGroups: PlotGroups[];
  mode: Mode;
}

export interface PlotGroups {
  name: string;
  description: string;
  plots: Plots[];
}

export interface Plots {
  key: string;
  text: string;
}

export interface SubPlot extends Plot {
  plotId: string;
  name: string;
}

/**
 * Type Guard
 */

export function isSubPlot(plot: Plot | SubPlot): plot is SubPlot {
  return "plotId" in plot && "name" in plot;
}

/**
 * Request Model
 */
export interface UpdatePlotPayload {
  novelId: string;
  plotGroups: PlotGroups[];
}

export interface UpdatePlotModePayload extends UpdatePlotPayload {
  mode: Mode;
}

export interface CreateSubPlotPayload {
  novelId: string;
  name: string;
  plotGroups: PlotGroups[];
  mode: Mode;
  callback: (plotId: string) => void;
}

export interface UpdateSubPlotPayload {
  novelId: string;
  plotId: string;
  name: string;
  plotGroups: PlotGroups[];
  mode: Mode;
}

export interface UpdateSubPlotSortOrderPayload {
  novelId: string;
  order: string[];
}

export interface DeleteSubPlotPayload {
  novelId: string;
  plotId: string;
  callback: () => void;
}

/**
 * Enum
 */
export const Mode = {
  /** 起承転結 */
  kishoutenketsu: "kishoutenketsu",
  /** 序破急 */
  johakyu: "johakyu",
  /** カスタム */
  custom: "custom",
} as const;
export type Mode = typeof Mode[keyof typeof Mode];

export const DisplayFormat = {
  /** 横 */
  HORIZONTAL: "horizontal",
  /** 縦 */
  VERTICAL: "vertical",
} as const;
export type DisplayFormat = typeof DisplayFormat[keyof typeof DisplayFormat];
